module.exports = __webpack_public_path__ + "img/logoarquivo.30807f39.png";